const QueueAction = {
  AddToQueue: 0,
  DispatchFromQueue: 1,
  RemoveFromQueue: 2,
};

export default QueueAction;
